import React, { useEffect } from 'react';
import CustomTitle from '../../components/UI/title/CustomTitle';
import { useDispatch, useSelector } from 'react-redux';
import { setButtonClick, setIconButton, setIsShowButton, setTextButton } from '../../store/buttonSlice';
import VideosContent from './VideosContent';
import './style.scss';
import MyButtonWhite from '../../components/UI/button/MyButtonWhite';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { setButtonClickNot, setIconButtonNot, setIsShowButtonNot, setTextButtonNot } from '../../store/buttonNotSlice';
import PageContent from '../../components/PageContent/PageContent';
import useMixpanel from '../../hooks/useMixpanel';
import MyButton from '../../components/UI/button/MyButton';

export default function VideoQuiz() {

    const dispatch = useDispatch();
    const history = useHistory();
    const buttonClicked = useSelector((state) => state.button.buttonClicked);
    const nextPage = useSelector((state) => state.appRoute.nextPage);
    const buttonNotClicked = useSelector((state) => state.buttonNot.buttonClicked);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const { trackP1Event } = useMixpanel();
    useEffect(() => {
        if (buttonClicked) {
            dispatch(setButtonClick(false));
            queryParams.set('video-ads', 1);
            trackP1Event('onboarding_video_ads', {
                user_response: 'I’m in!'
            })
            history.push({
                pathname: nextPage,
                search: `?${queryParams.toString()}`
            });
        }
    }, [buttonClicked, dispatch]);

    useEffect(() => {
        if (buttonNotClicked) {
            dispatch(setButtonClickNot(false));
            trackP1Event('onboarding_video_ads', {
                user_response: 'Not sure'
            })
            history.push({
                pathname: nextPage,
                search: `?${queryParams.toString()}`
            });
        }
    }, [buttonNotClicked, dispatch]);

    useEffect(() => {
        dispatch(setIsShowButton(false));
        dispatch(setTextButton('I’m in!'));
        dispatch(setIconButton('Tick'));

        dispatch(setIsShowButtonNot(false));
        dispatch(setTextButtonNot('Not sure'));
        dispatch(setIconButtonNot('not'));
    }, []);

    const handleClick = () => {
        queryParams.set('video-ads', 1);
        trackP1Event('onboarding_video_ads', {
            user_response: 'I’m in!'
        })
        history.push({
            pathname: nextPage,
            search: `?${queryParams.toString()}`
        });
    }

    const handleClickNot = () => {
        trackP1Event('onboarding_video_ads', {
            user_response: 'Not sure'
        })
        history.push({
            pathname: nextPage,
            search: `?${queryParams.toString()}`
        });
    }

    return (
        <div className="page video-quiz page--with-notButton">
            <PageContent>
                <div className="page-content">
                    <CustomTitle
                        style={{ marginBottom: '12rem' }}
                        title={'Want viral video ads made with AI?'}
                    />
                    <p className="text" style={{ marginBottom: '24rem' }}>
                        AI does the talking, writing, and editing
                    </p>
                    <div className="video-quiz-wrapper">
                        <VideosContent />
                    </div>

                </div>
            </PageContent>

            <div className="block-button">

                <MyButtonWhite
                    style={{ marginBottom: '8rem' }}
                    buttonText={'Not sure'}
                    buttonTime={'150'}
                    buttonIcon={'not'}
                    onClick={() => handleClickNot()}
                />

                <MyButton
                    buttonStatus={''}
                    buttonTime={'150'}
                    buttonText={'I’m in!'}
                    buttonIcon={'Tick'}
                    onClick={() => handleClick()}
                // className={`${buttonError ? 'error' : ''
                //     }`}
                >

                </MyButton>


            </div>

        </div>
    );
}
